const possibelTypes = {
    MediaItem: ["Image", "Video", "YoutubeVideo"],
    Game: ["Quiz", "OutcomeQuiz"],
};

export default possibelTypes;
